import {db} from '../utils/firebase'

export const apiGetAllTracks = async () => {
    try {
        const tracks = [],
            planets = await db.collection('planetsCache').get(),
            locales = await db.collection('languages').get().then((snapshot) => {
                const languages = [];
                snapshot.forEach(doc => languages.push(doc.id));
                return languages;
            })

        if (planets.empty || !locales || (locales && !locales.length)) {
            return [];
        }

        for (let planet of planets.docs) {
            const planetData = planet.data();

            const playlists = planetData.playlists;
            for (let playlist of playlists) {
                for (const locale of locales) {
                    if (playlist[`tracks_${locale}`]) {
                        for (let track of playlist[`tracks_${locale}`]) {
                            tracks.push({
                                id: track.ref,
                                planet: planetData,
                                ...track,
                            });
                        }
                    }
                }
            }
        }

        return tracks;
    } catch (error) {
        console.log(error);
        return [];
    }
};
